import { render, staticRenderFns } from "./new-line-recharge.vue?vue&type=template&id=0bb221a2&scoped=true&"
import script from "./new-line-recharge.vue?vue&type=script&lang=js&"
export * from "./new-line-recharge.vue?vue&type=script&lang=js&"
import style0 from "./new-line-recharge.vue?vue&type=style&index=0&id=0bb221a2&lang=scss&scoped=true&"
import style1 from "./new-line-recharge.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb221a2",
  null
  
)

export default component.exports